import { useEffect, useState } from 'react';
import { cssVar, getLuminance } from 'polished';

import { useDarkMode } from './useDarkMode';

export const useAccessibleColor = (primaryColorVar: string, primaryForegroundVar: string) => {
  const [foregroundColor, setForegroundColor] = useState(`var(${primaryForegroundVar})`);
  const isDarkMode = useDarkMode();

  useEffect(() => {
    const primaryColor = cssVar(primaryColorVar);
    const primaryForeground = cssVar(primaryForegroundVar);

    if (primaryColor && primaryForeground) {
      const luminance = getLuminance(primaryColor.toString());
      if (luminance <= 0.5) {
        setForegroundColor(isDarkMode ? `var(--bfc-ring)` : `var(${primaryColorVar})`);
      } else {
        setForegroundColor(isDarkMode ? `var(${primaryColorVar})` : `var(${primaryForegroundVar})`);
      }
    }
  }, [primaryColorVar, primaryForegroundVar, isDarkMode]);

  return foregroundColor;
};
